module.exports = __webpack_public_path__ + "img/SAFETY-COMPONENTS.c31327aa.jpg";